import importedWrapPageElement from './gatsby/wrapPageElement';
import importedWrapRootElement from './gatsby/wrapRootElement';

export const wrapPageElement = importedWrapPageElement;
export const wrapRootElement = importedWrapRootElement;
